import { HttpError } from '@rd/types';
import {
  ContactUsActions,
  ContactUsActionTypes,
} from '../actions/contact-us.actions';

export interface ContactUsState {
  createSupportTicket: {
    loading: boolean;
    error: HttpError | null;
    success: boolean;
  };
}

const initialState: ContactUsState = {
  createSupportTicket: {
    loading: false,
    error: null,
    success: false,
  },
};

export function contactUsReducer(
  state: ContactUsState = initialState,
  action: ContactUsActions,
): ContactUsState {
  switch (action.type) {
    case ContactUsActionTypes.CREATE_SUPPORT_TICKET:
      return {
        ...state,
        createSupportTicket: {
          loading: true,
          error: null,
          success: false,
        },
      };

    case ContactUsActionTypes.CREATE_SUPPORT_TICKET_SUCCESS:
      return {
        ...state,
        createSupportTicket: {
          loading: false,
          error: null,
          success: true,
        },
      };

    case ContactUsActionTypes.CREATE_SUPPORT_TICKET_FAIL:
      return {
        ...state,
        createSupportTicket: {
          loading: false,
          error: action.payload.error,
          success: false,
        },
      };

    case ContactUsActionTypes.RESET_FORM:
      return {
        ...state,
        createSupportTicket: {
          loading: false,
          error: null,
          success: false,
        },
      };

    default:
      return state;
  }
}
